import React from 'react';
import Form from '../Form';

class ParkBetForm extends Form {
    onSubmit(e) {
        e.preventDefault();

        Form.prototype.onSubmit.call(this, e);
    }

    renderForm() {
        return (
            <div className="park-bet-form">
                { this.getCheckbox('status', 'Park bet') }
            </div>
        );
    }
}

export default ParkBetForm;
